import React from "react";
import { cva } from "class-variance-authority";

import { Spinner } from "components/Spinner";
import { cn } from "utils/cn";

const buttonVariants = cva("flex justify-center rounded-md font-semibold leading-6 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2", {
  variants: {
    color: {
      primary: "bg-indigo-600 text-white hover:bg-indigo-700 focus-visible:outline-indigo-600",
      danger: "bg-red-600 text-white hover:bg-red-700 focus-visible:outline-red-600",
      success: "bg-green-600 text-white hover:bg-green-700 focus-visible:outline-green-600",
      warning: "bg-orange-600 text-white hover:bg-orange-700 focus-visible:outline-orange-700",
      secondary: "bg-neutral-200 text-neutral-600 hover:bg-neutral-300 focus-visible:outline-neutral-300",
    },
    size: {
      xs: "px-2 py-1.5 text-xs",
      sm: "px-3 py-1.5 text-sm",
      md: "text-md p-3",
      lg: "px-5 py-3 text-lg",
    },
    disabled: {
      true: "",
      false: "",
    },
  },
  compoundVariants: [
    {
      disabled: true,
      class: "border-neutral-100 bg-neutral-100 text-neutral-400 hover:border-neutral-100 hover:bg-neutral-100 hover:text-neutral-400",
    },
  ],
  defaultVariants: {
    color: "primary",
    size: "md",
  },
});

const Button = React.forwardRef(({ children, color, size, disabled, loading, className, ...props }, ref) => {
  return (
    <button type="button" disabled={disabled} className={cn(buttonVariants({ color, disabled, size }), className)} ref={ref} {...props}>
      {loading ? <Spinner size={size} color={color} /> : children}
    </button>
  );
});

Button.displayName = "Button";

export { Button };
